// Libraries
import I18n from 'i18next'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Card, Icon, Tooltip, Tag, Button } from 'antd'
import { get, isNil, head, split, last, includes, map, defaultTo } from 'lodash'

// Resources
import { FormLayout } from 'Components'
import { getPermitActionsRights } from 'Services/permitsActionsRights'
import ButtonDownload from 'Views/Permits/Components/buttons/ButtonDownload'
import ButtonSign from 'Views/Permits/Components/buttons/ButtonSign'
import ButtonCapacityControl from 'Views/Permits/Components/buttons/ButtonCapacityControl'
import ButtonControl from 'Views/Permits/Components/buttons/ButtonControl'
import ButtonCancel from 'Views/Permits/Components/buttons/ButtonCancel'
import ButtonClose from 'Views/Permits/Components/buttons/ButtonClose'
import ButtonValidateControl from 'Views/Permits/Components/buttons/ButtonValidateControl'
import ButtonConfirm from 'Views/Permits/Components/buttons/ButtonConfirm'
import ButtonDuplicate from 'Views/Permits/Components/buttons/ButtonDuplicate'
import ButtonDelete from 'Views/Permits/Components/buttons/ButtonDelete'

class InformationTab extends Component {
  static propTypes = {
    // Gestion de l'interface du formulaire
    formLayout: PropTypes.object,

    // TÃ©moins de charge API
    loading: PropTypes.bool,
    isDownloading: PropTypes.bool,

    // Utilisateur connectÃ©
    profile: PropTypes.object,

    // Fonctions hÃ©ritÃ©s du constructeur
    constructorFunctions: PropTypes.object,

    // DonnÃ©es de la vue
    data: PropTypes.object,
    type: PropTypes.string,

    goBack: PropTypes.func,
    onValuesChange: PropTypes.func
  }

  static defaultProps = {
    // Gestion de l'interface du formulaire
    formLayout: {},

    // TÃ©moins de charge API
    loading: true,
    isDownloading: false,

    // Utilisateur connectÃ©
    profile: {},

    // Fonctions hÃ©ritÃ©s du constructeur
    constructorFunctions: {},

    // DonnÃ©es de la vue
    data: {},
    type: 'workingPermit'
  }

  constructor(props) {
    super(props)

    this.state = {}
  }

  componentDidMount = () => {}

  renderButtons = () => {
    const {
      constructorFunctions,
      data: permit,
      profile,
      type,
      isDownloading
    } = this.props

    const {
      notReader,
      canBeSigned,
      canBeEdited,
      canBeCancelled,
      canBeClosed,
      canValidateControl,
      canAskConfirmRequest,
      canDuplicate,
      canDelete
    } = getPermitActionsRights({
      profile,
      permit,
      type
    })

    const buttons = []

    // Affichage du bouton de tÃ©lÃ©chargement
    buttons.push(
      <ButtonDownload
        key='download'
        type={type}
        permit={permit}
        isDownloading={isDownloading}
        constructorFunctions={constructorFunctions}
      />
    )

    if (notReader) {
      // Signature du document
      // Lorsque le permis n'est pas encore signÃ©, il est possible de le tÃ©lÃ©charger, le signer et importer le scan
      // todo: check if main permit is signed
      if (canBeSigned) {
        buttons.push(
          <ButtonSign
            key='sign'
            type={type}
            constructorFunctions={constructorFunctions}
          />
        )
      }

      // Controle du permis de capacitÃ©
      if (canBeEdited.capacityPermit) {
        buttons.push(
          <ButtonCapacityControl
            key='edit'
            constructorFunctions={constructorFunctions}
          />
        )
      }

      // Controle du permis de nettoyage
      if (canBeEdited.cleaningPermit) {
        buttons.push(
          <ButtonControl
            key='control'
            constructorFunctions={constructorFunctions}
          />
        )
      }

      // Annulation du permit en attente
      // Lâutilisateur peut annuler le permis seulement lorsque le statut est âen attenteâ.
      // Avant lâannulation du permis, on lui demande dâindiquer le motif dâannulation en saisie libre.
      if (canBeCancelled) {
        buttons.push(
          <ButtonCancel
            key='cancel'
            constructorFunctions={constructorFunctions}
          />
        )
      }

      // Cloture du permit terminÃ©
      // Lorsque le permis est terminÃ© et contrÃ´lÃ©, alors un bouton âclÃ´turerâ est actif.
      // En cliquant dessus, le permis passe en statut âclÃ´turÃ©â.
      // La clÃ´ture est possible uniquement si les permis feux/fouille/nettoyage/capacitÃ© associÃ©s sont clÃ´turÃ©s.
      if (canBeClosed) {
        buttons.push(
          <ButtonClose
            key='close'
            type={type}
            constructorFunctions={constructorFunctions}
          />
        )
      }

      // ContrÃ´le de fin de chantier
      // Lorsque le permis est en statut âterminÃ©â, un bouton permet dâindiquer que le contrÃ´le de fin de chantier a Ã©tÃ© effectuÃ© : indiquer la date et lâheure. (champ obligatoire)
      // Action uniquement active si le permis a Ã©tÃ© signÃ©.
      else if (canValidateControl) {
        buttons.push(
          <ButtonValidateControl
            key='validateControl'
            type={type}
            constructorFunctions={constructorFunctions}
          />
        )
      }

      // Only for the main permit
      if (canAskConfirmRequest) {
        buttons.push(
          <ButtonConfirm
            key='confirmRequest'
            constructorFunctions={constructorFunctions}
          />
        )
      }

      if (canDuplicate) {
        buttons.push(
          <ButtonDuplicate
            key='duplicate'
            type={type}
            constructorFunctions={constructorFunctions}
          />
        )
      }

      if (canDelete) {
        buttons.push(
          <ButtonDelete
            key='delete'
            type={type}
            constructorFunctions={constructorFunctions}
          />
        )
      }
    }

    return buttons
  }

  /**
   * RÃ©sumÃ© d'informations sur le permis
   */
  renderHeader = () => {
    const { type, data: permit, goBack, loading } = this.props

    const associatedColors = {
      waiting: '',
      cancelled: 'red',
      closed: 'blue',
      finished: 'orange',
      opened: 'green',
      excellent: 'green',
      good: 'gold',
      poor: 'volcano',
      requested: 'cyan'
    }

    if (loading) {
      return null
    }

    return (
      <header>
        <div className='resume'>
          {/* Information sur le permis */}
          <div className='information'>
            {/* Bouton de retour */}
            {!!goBack && (
              <Button
                className='btn-back-permis-info'
                icon='arrow-left'
                type='ghost'
                onClick={goBack}
              />
            )}
            {/* Identifiant du permis */}
            <h2 className='permit-id'>
              {/* IcÃ´ne du permis */}
              <Icon
                type={
                  type === 'firePermit'
                    ? 'fire'
                    : type === 'searchPermit'
                    ? 'search'
                    : type === 'capacityPermit'
                    ? 'carry-out'
                    : 'file-done'
                }
              />

              {/* ID du permis */}
              <span>{`#${get(permit, 'permitID')}`}</span>

              {/* Statut du permis */}
              {!isNil(get(permit, 'status')) && (
                <Tooltip title={get(permit, 'reason.reason')}>
                  <Tag
                    className='permit-status'
                    color={get(associatedColors, get(permit, 'status'))}
                  >
                    {get(permit, 'status') === 'finished' && (
                      <Icon type='warning' />
                    )}
                    {I18n.t(
                      `pages.permits.fields.status.options.${get(
                        permit,
                        'status'
                      )}.title`
                    )}
                  </Tag>
                </Tooltip>
              )}
            </h2>

            {/* Entreprise */}
            <p className='permit-company'>
              {I18n.t('pages.permits.details.companyName', {
                company: get(permit, 'company'),
                day: moment(get(permit, 'dateCreated')).format('L'),
                hour: moment(get(permit, 'dateCreated')).format('HH:mm')
              })}
            </p>

            {/* Jour et heures de validitÃ© */}
            {!isNil(get(permit, 'validityDate')) &&
              !isNil(get(permit, 'validityHours')) &&
              moment(get(permit, 'validityDate')).isValid() && (
                <p className='permit-validityDate'>
                  {I18n.t('pages.permits.details.validityDateHours', {
                    date: moment(get(permit, 'validityDate')).format('L'),
                    start: head(split(get(permit, 'validityHours'), ' - ')),
                    stop: last(split(get(permit, 'validityHours'), ' - '))
                  })}
                </p>
              )}

            {/* PÃ©riode de validitÃ© */}
            {!isNil(get(permit, 'validityPeriod')) &&
              moment(get(permit, 'validityDate.startDate')).isValid() &&
              moment(get(permit, 'validityDate.endDate')).isValid() && (
                <p className='permit-validityPeriod'>
                  {I18n.t('pages.permits.details.validityPeriod', {
                    startDate: moment(
                      get(permit, 'validityPeriod.startDate')
                    ).format('L'),
                    endDate: moment(
                      get(permit, 'validityPeriod.endDate')
                    ).format('L')
                  })}
                </p>
              )}

            {/* Date de signature */}
            {get(permit, 'isSigned') && (
              <p className='permit-signed'>
                {I18n.t('pages.permits.details.dateSigned', {
                  day: moment(get(permit, 'dateSigned')).format('L'),
                  hour: moment(get(permit, 'dateSigned')).format('HH:mm')
                })}
              </p>
            )}

            {/* Date de contrÃ´le de chantier */}
            {get(permit, 'isControlled') && (
              <p className='permit-controlled'>
                {I18n.t('pages.permits.details.dateControlled', {
                  day: moment(get(permit, 'dateControlled')).format('L'),
                  hour: moment(get(permit, 'dateControlled')).format('HH:mm')
                })}
              </p>
            )}
          </div>
        </div>

        <div className='buttons'>{this.renderButtons()}</div>
      </header>
    )
  }

  render() {
    const {
      formLayout,
      loading,
      profile,
      type,
      constructorFunctions,
      data: permit,
      onValuesChange
    } = this.props

    const isUserReader = includes(map(get(profile, 'roles'), 'name'), 'READER')
    const isUserExtern =
      includes(map(get(profile, 'roles'), 'name'), 'EXTERN_CREATOR') ||
      includes(map(get(profile, 'roles'), 'name'), 'EXTERN_READER')

    // Masquage du bouton de modification si le permis n'est plus actif
    formLayout.actions.update.hidden =
      isUserReader ||
      isUserExtern ||
      includes(['closed', 'cancelled'], get(permit, 'status')) ||
      (get(permit, 'status') !== 'requested' && isUserExtern)

    if (type === 'firePermit') {
      permit.validityDate = defaultTo(
        get(permit, 'validityPeriod.startDate'),
        moment()
      )
    }

    return (
      <Card className='tab information'>
        {/* Rendu du rÃ©sumÃ© d'informations */}
        {this.renderHeader()}

        {!loading && (
          <FormLayout
            data={permit}
            loading={loading}
            onFormValuesChange={onValuesChange}
            onChange={value => {
              switch (type) {
                case 'firePermit':
                  get(constructorFunctions, 'askUpdateFirePermit')(value)
                  break
                case 'searchPermit':
                  get(constructorFunctions, 'askUpdateSearchPermit')(value)
                  break
                case 'capacityPermit':
                  get(constructorFunctions, 'askUpdateCapacityPermit')(value)
                  break
                case 'cleaningPermit':
                  get(constructorFunctions, 'askUpdateCleaningPermit')(value)
                  break
                default:
                  get(constructorFunctions, 'askUpdatePermit')(value)
                  break
              }
            }}
            {...formLayout}
          />
        )}
      </Card>
    )
  }
}

export default InformationTab
